/* ============================================================
   ROYAL PERFUMERIE — "ASCENT" JS LAYER (Shopify)
   3D cursor tilt for product cards and promo banners.
   Self-contained; remove with ascent.css to revert.
   ============================================================ */
(function () {
  "use strict";
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var touch = matchMedia("(hover: none)").matches;
  if (reduce || touch) return;

  function bindTilt(selector, maxY, maxX, z) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (el.dataset.rpTilt) return;
      el.dataset.rpTilt = "1";
      var tk = false, lx = 0, ly = 0, r = null;
      function apply() {
        tk = false; if (!r) return;
        var px = (lx - r.left) / r.width - 0.5;
        var py = (ly - r.top) / r.height - 0.5;
        el.style.transform =
          "rotateY(" + (px * maxY).toFixed(2) + "deg)" +
          " rotateX(" + (-py * maxX).toFixed(2) + "deg)" +
          " translateZ(" + z + "px)";
      }
      el.addEventListener("mouseenter", function () { r = el.getBoundingClientRect(); });
      el.addEventListener("mousemove", function (e) {
        lx = e.clientX; ly = e.clientY;
        if (!tk) { tk = true; requestAnimationFrame(apply); }
      });
      el.addEventListener("mouseleave", function () { el.style.transform = ""; });
    });
  }

  function init() {
    bindTilt(".ge-card, .product-card", 12, 10, 6);
    bindTilt(".ge-promo, .ge-collection-banner, .rp-oasis", 8, 7, 10);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }

  /* re-bind after Shopify section reloads in the editor */
  document.addEventListener("shopify:section:load", init);
})();
